import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IAssignment } from 'src/app/assignment/models/assignment';
import { IEmployee } from 'src/app/employee/employee';
import { AppStateInterface } from 'src/app/stores/global/appState.interface';
import { getCurrentEmployee } from 'src/app/stores/global/current-employee/current-employee.store';
import { IStartTimeEntryRequest, ITimeEntry } from 'src/app/time-tracking/models/time-entry';
import { ITimeEntryCategory } from 'src/app/time-tracking/models/time-entry-category';
import { TimeEntryCategoryService } from 'src/app/time-tracking/services/time-entry-category.service';
import { TimeEntryService } from 'src/app/time-tracking/services/time-entry.service';
import { TimeEntriesStorageService } from 'src/app/time-tracking/storage/time-entries-storage.service';
import { ObjectIdIsNotNullValidator } from '../validators/objectIdIsNotNull.validator';

@UntilDestroy()
@Component({
    selector: 'app-time-tracking-start-stop',
    templateUrl: './time-tracking-start-stop.component.html',
    styleUrls: ['./time-tracking-start-stop.component.scss'],
    standalone: false
})
export class TimeTrackingStartStopComponent implements OnInit {

  constructor(
    private timeEntryService: TimeEntryService,
    private timeEntryCategoriesService: TimeEntryCategoryService,
    private timeEntriesStorage : TimeEntriesStorageService,
    private store: Store<AppStateInterface>
  ) {
    this.timeEntriesStorage.listTimeEntriesOfCurrentUserToday(); 
  }

  @Input() assignment: IAssignment = null;
  @Output() onTimeEntryChange : EventEmitter<undefined> = new EventEmitter

  timeEntries$ : Observable<ITimeEntry[]> =
  this.timeEntriesStorage.timeEntries$;

  form: UntypedFormGroup;
  timeEntryisRunning = true;

  timeEntryCategories: ITimeEntryCategory[] = [];

  defaultItem: ITimeEntryCategory = {
    id: null,
    name: "Wähle eine Tätigkeit",
    isProductive: null,
    color: null,
    sortOrder: 0
  }

  get timeEntryCategoryControll(){
    return this.form.controls['timeEntryCategory'];
  }

  ngOnInit(): void {
    this.initForm();
    this.loadTimeEntryCategories();
    this.hasRunningTimeEntry();
  }

  hasRunningTimeEntry(){
    this.timeEntries$.pipe(untilDestroyed(this))
    .subscribe(timeEntries => {
      const activeTimeEntry = timeEntries.find((timeEntry) => !timeEntry.stop);

      if(activeTimeEntry?.assignmentId != this.assignment?.id && this.assignment){
          this.timeEntryisRunning = false
      } else if(activeTimeEntry){
        this.timeEntryisRunning = true;
        this.form.get('timeEntryCategory').clearValidators();
        this.form.get('timeEntryCategory').reset();
      } 
      else {
        this.timeEntryisRunning = false;
      }

    })
  }

  // TODO: Check if TimeEntries have already been loaded
  loadTimeEntryCategories(){
    this.timeEntryCategoriesService.searchTimeEntryCategories({pageNumber: 0, pageSize: 999999})
    .pipe(untilDestroyed(this))
    .subscribe(response => {
      this.timeEntryCategories = response.data;
    })
  }

  initForm(){
    this.form = new UntypedFormGroup({
      // The "Wähle eine Tätigkeit" default item is an object with a null id, so it would
      // satisfy Validators.required and start a time entry without a category.
      timeEntryCategory: new UntypedFormControl(null, ObjectIdIsNotNullValidator()),
      assignment: new UntypedFormControl(null),
      assignmentService: new UntypedFormControl(null),
    })

    this.form.get('assignmentService').valueChanges
    .pipe(untilDestroyed(this))
    .subscribe(assignmentService => {
      const timeEntryCategory = this.timeEntryCategories.find(timeEntryCategory => timeEntryCategory.id == assignmentService?.service?.timeEntryCategoryId);
      this.form.get('timeEntryCategory').patchValue(timeEntryCategory)
    })
  }

  onSubmit(){
    console.log("form submit",this.form);
    const formValues = this.form.value;
    console.log("form submit",formValues);

    if(this.timeEntryisRunning)
    {
      this.timeEntryService.stopTimeEntry()
        .pipe(untilDestroyed(this))
        .subscribe(response => {
          this.timeEntryCategoryControll.enable();
          this.store.dispatch(getCurrentEmployee());
          this.timeEntriesStorage.listTimeEntriesOfCurrentUserToday();
          this.onTimeEntryChange.emit();
          this.form.get('timeEntryCategory').setValidators(ObjectIdIsNotNullValidator());
        })
    }
    else {
      const request : IStartTimeEntryRequest = {
        timeEntryCategoryId: formValues.timeEntryCategory?.id,
        assignmentId: formValues.assignment?.id ?? this.assignment?.id,
        assignmentServiceId: formValues.assignmentService?.id
      }
      this.timeEntryService.startTimeEntry(request)
      .subscribe(response => {
        this.timeEntryCategoryControll.disable();
        this.timeEntriesStorage.listTimeEntriesOfCurrentUserToday();
        this.onTimeEntryChange.emit();
        this.form.reset();
      })
    }
  }

  

}
